import React from 'react';
import StageBackground from '../../DeviationBackground/StageBackground';
import DeviationFullView from '../../DeviationViews/Full';
import DuperbrowsePaddles from '../../Duperbrowse/DuperbrowsePaddles';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import s from './CommissionStage.scss';
const CommissionStage = ({ deviation })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root'],
        "data-hook": BiDataHook.DEVIATION_ART_STAGE
    }, /*#__PURE__*/ React.createElement(StageBackground, {
        deviation: deviation
    }), /*#__PURE__*/ React.createElement(DeviationFullView, {
        deviation: deviation
    }), /*#__PURE__*/ React.createElement(DuperbrowsePaddles, {
        className: s['duperbrowse']
    }));
};
CommissionStage.displayName = 'CommissionStage';
export default CommissionStage;
